import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { CellProps, Row } from 'src/components/DataTable/types';
import { useAppConfig } from 'src/config';
import { SiteDeviceProjectItem } from 'src/pages/Sites/types';
import { getNamespaceVersionStatus } from '../utils';

const STATUS_INDICATOR = {
  mismatch: {
    color: 'error.main',
    tooltip:
      'One or more images in this namespace do not match the expected version',
  },
  noBaseline: {
    color: 'warning.main',
    tooltip:
      'One or more images in this namespace have no expected version to verify against',
  },
} as const;

function NamespaceNameCell({ item, value }: CellProps<any, Row>) {
  const row = item as unknown as SiteDeviceProjectItem;
  const { edgePlatformStandardVersion } = useAppConfig();
  const status = getNamespaceVersionStatus(row?.pods, edgePlatformStandardVersion);
  const indicator = status !== 'ok' ? STATUS_INDICATOR[status] : undefined;

  return (
    <Box display="flex" alignItems="center" gap={0.75}>
      <span>{value}</span>
      {indicator && (
        <Tooltip title={indicator.tooltip}>
          <Box
            component="span"
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: indicator.color,
              display: 'inline-block',
            }}
          />
        </Tooltip>
      )}
    </Box>
  );
}

export default NamespaceNameCell;
